import { ApiApplicationID, ApiProject } from '../models';

export const extractHasMultipleA2APlannings = (project: ApiProject): boolean => {
    if (!project.variants) {
        return false;
    }

    return project.variants.flatMap(variant => variant.plannings ?? []).length > 1;
};
